import { Box, Result } from '@/lib/types';
import { AxiosError } from 'axios';
import { media_client } from '../../';

export default {
    async add(value: string, title: string, category: string, description?: string, selected_tags?: string[]): Promise<Result<string, AxiosError>>{

        try{

            const response = await media_client.put(`/links`, {
                title,
                value,
                description,
                category,
                tags: selected_tags
            });
            return {
                ok: new Box<string>(response.data.id),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        } 

    }
}